import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-76682459"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "large_block_text" };
const _hoisted_2 = { class: "container inner" };
const _hoisted_3 = { class: "row" };
const _hoisted_4 = { class: "container-sm" };
const _hoisted_5 = ["innerHTML"];
export default /*#__PURE__*/ _defineComponent({
    __name: 'large_block_text',
    props: ['d'],
    setup(__props) {
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                        _createElementVNode("div", _hoisted_4, [
                            _createElementVNode("article", {
                                innerHTML: __props.d.body
                            }, null, 8, _hoisted_5)
                        ])
                    ])
                ])
            ]));
        };
    }
});
